<script>
import moment from "moment";
import {money_format} from "@/utils";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";

const startOfMonth = moment()
    .clone()
    .startOf("month")
    .format("YYYY-MM-DD");
const endOfMonth = moment()
    .clone()
    .endOf("month")
    .format("YYYY-MM-DD");

export default {
  name: "locations-roi",
  components: {
    VueCtkDateTimePicker,
    DataTableSection
  },
  data() {
    return {
      search: "",
      selected: [],
      items: [],
      item: null,
      snackbar: false,
      text: "Loading locations...",
      timeout: 2000,
      loading: true,
      dtpicker: {start: startOfMonth, end: endOfMonth},
      maxDate: moment().format("YYYY-MM-DD"),
      tableDataParam: {
        getters: 'getLocationsROI',
        dispatchFunction: '', //empty this for manual trigger in mount
        setQuery: 'setDateRange',
        queryValue: {start: startOfMonth, end: endOfMonth},
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: true,
            value: "name",
            width: "150px"
          },
          {text: "Street", value: "street", width: "150px"},
          {text: "Sales", value: "total_sales", sortable: true, width: "150px"},
          {text: "Previous Sales", value: "previous_total_sales", sortable: true, width: "150px"}
        ]
      },
      customRenderers: [
        {
          field: "name",
        },{
          field: "street",
        },{
          field: "total_sales",
        },{
          field: "previous_total_sales",
        },{
          field: "new_customers_percentage",
        },{
          field: "repeat_customers_percentage",
        }
      ],
      firstLoadDone: false,
      datatableColumn: {
        selected: [
          {text: "Sales", value: "total_sales", sortable: true},
          {text: "Previous Sales", value: "previous_total_sales", sortable: true}
        ],
        defaultFeaders: [
          {
            text: "Name",
            align: "left",
            sortable: true,
            value: "name",
            width: "150px"
          },
          {text: "Street", value: "street",width: "150px"},
          {text: "Potential ROI", value: "potential_roi", sortable: true,width: "150px"}
        ]
      },
      datatableColumnItem:[
        {text: "Sales", value: "total_sales", sortable: true},
        {text: "Previous Sales", value: "previous_total_sales", sortable: true},
        {text: "New Customers", value: "new_customers_percentage" },
        {text: "Repeat Customers", value: "repeat_customers_percentage"}
      ],
      maxDisplay: 1
    };
  },
  computed: {
    searchTrigger() {
      return this.search;
    },

    likesAllItems() {
      return this.datatableColumn.selected.length === this.datatableColumnItem.length;
    },
    likesSomeItem() {
      return this.datatableColumn.selected.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  async mounted() {
    // this.loading = true;
    await this.firstLoadDatePick();
    await this.searchLocations()
  },
  watch: {
    searchTrigger(q) {
      let componentEvent = this.$refs.dataTableComponent
      componentEvent.updateSearchField(q)      
    },
    dtpicker(newVal) {
      if (newVal == undefined) {
        let last365 = moment(this.maxDate).subtract(1, 'years')
        last365 = last365.format("YYYY-MM-DD");
        // let today = moment()
        // today = today.format("YYYY-MM-DD");

        this.dtpicker = { start: last365, end: this.maxDate };
      }
    },
    "datatableColumn.selected"(selectedAdded){
      let addedColumn = []
      for (let i = 0; i < selectedAdded.length; i++) {
        selectedAdded[i].width = '150px'
        addedColumn.push(selectedAdded[i]);
      }
      this.tableDataParam.headers = [...this.datatableColumn.defaultFeaders] // reset the default header before adding new
      this.tableDataParam.headers  = [...this.tableDataParam.headers , ...addedColumn] // merging the default and selected row
    },
    "items"(){
       this.loading = false
    }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.datatableColumn.selected = [];
        } else {
          this.datatableColumn.selected =  this.datatableColumnItem;
        }
      });
    },
    exportItems() {
      if (this.items.length <= 0) {
        alert("No data to Export")
      }else{
        let items = [];
          for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i];
            items.push({
              id: item.id,
              pos_ID: item.pos_id ,
              name: item.name ,
              street: item.street ,
              city: item.city ,
              state: item.state ,
              zip: item.zip ,
              potential_roi: item.potential_roi ,
              total_sales: item.total_sales ,
              previous_total_sales: item.previous_total_sales ,
              previous_potential_roi: item.previous_potential_roi,
              new_customers_percentage: item.new_customers_percentage,
              repeat_customers_percentage: item.repeat_customers_percentage
            });

          }
          let csv = this.$papa.unparse(items);
          this.$papa.download(
              csv,
              `LocationSummary-${moment().format("YYYY-MM-DD-HH-mm")}`
          );
      }
    },
    numberWithCommas(x) {
      return money_format(x);
    },
    salesFormat(value) {
      if (value) {
        value = parseFloat(value);
        return money_format(value);
      } else {
        return "0.00";
      }
    },
    showDemographic(item) {
      this.$store.commit("setLocationId", item.id);
      window.sessionStorage.setItem("selected_location", item.id);
      localStorage.setItem("selected_location", JSON.stringify(item));
      this.$router.push(`/dashboard`);
    },
    getPreviousSales(item) {
      let total_diff = item.total_sales - item.previous_total_sales;
      let previous_sales =
          item.previous_total_sales > 0
              ? total_diff / item.previous_total_sales
              : total_diff;
      return money_format(previous_sales);
    },
    async searchLocations() {
      this.loading = true
      if (this.dtpicker.start && this.dtpicker.end) {
        this.$store.commit("setDateRange", this.dtpicker);
        await this.$store.dispatch("getLocationsROI");
      }
      setTimeout(() => {
        this.loading = false
      }, 2000);
    },
    async firstLoadDatePick(){
      var accountSetting = await this.$store.getters["getAccountSettings"];
      if (!accountSetting.length){
        await this.$store.dispatch("getAccountSettings");
        accountSetting = await this.$store.getters["getAccountSettings"];
      }
      let aggregatedDate = accountSetting.company_details.company['aggregated_date']
      this.maxDate = moment(aggregatedDate).format("YYYY-MM-DD")

      if (!this.firstLoadDone ){ 
        this.firstLoadDone = true

        let current = new Date()
        let enddate = `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`
        let startdate = `${current.getFullYear() - 1}-${current.getMonth() + 1}-${current.getDate()}`
        
        this.dtpicker.start = startdate // this set the value of date picker //initial first load set date range
        this.dtpicker.end = enddate
        this.tableDataParam.queryValue.start =startdate
        this.tableDataParam.queryValue.end =enddate

        if ( moment(this.maxDate).format("YYYY-MM-DD") < moment(enddate).format("YYYY-MM-DD") ){
          let last365 = moment(this.maxDate).subtract(1, 'years')
          last365 = last365.format("YYYY-MM-DD");

          this.dtpicker.start  = last365
          this.dtpicker.end  = moment(this.maxDate).format("YYYY-MM-DD");
          this.tableDataParam.queryValue.end  = moment(this.maxDate).format("YYYY-MM-DD");
        }
      }
    },
    syncItems(itemsCollection) {
      this.items = itemsCollection
    },
    whenDtClosed(){
      if(this.dtpicker.end == null && this.dtpicker.start != null) {
        this.dtpicker.end = this.maxDate
      }
    },
  }
};
</script>

<template>
  <v-card flat>
    <div class="d-flex align-items-center justify-content-center">
      <div class="mr-2" style="width:300px">
        <VueCtkDateTimePicker
            v-model="dtpicker"
            :max-date="maxDate"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select date range"
            range
            id="mylocationdtpicker"
            @is-hidden="whenDtClosed()"
        />
      </div>

      <div class="ml-2">
        <v-btn
            depressed
            color="primary"
            id="myBtn"
            @click="searchLocations"
            :loading="loading"
        >
            <!-- :loading="loading"
            :disabled="loading" -->
          <v-icon> mdi-magnify</v-icon>
        </v-btn>
      </div>
      <div class="ml-2">
        <v-btn
            depressed
            text
            outlined
            @click="exportItems"
        >
          EXPORT
        </v-btn>
      </div>
    </div>
    <div
        class="btn-toolbar justify-content-end mt-5 mb-5"
        role="toolbar"
        aria-label="Toolbar with button groups"
    > <div class="height40 mwitdh200 mr-3">
        <v-select
              label="Table Metrics"
              v-model="datatableColumn.selected"
              :items="datatableColumnItem"
              multiple
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              return-object
            >
              <template v-slot:prepend-item>
                <v-divider class="mt-2"></v-divider>
                <v-list-item ripple @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="datatableColumn.selected.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template
                v-if="datatableColumn.selected.length > 1"
                v-slot:selection="{ item, index }"
              >
                <span v-if="index === maxDisplay">
                  {{ datatableColumn.selected.length }} selected
                </span>
              </template>
            </v-select>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text" id="btnGroupAddon2">
            <b-icon icon="search"></b-icon>
          </div>
        </div>
        <b-form-input
            v-model="search"
            placeholder="Search"
            style="height: auto;"
        ></b-form-input>
      </div>
    </div>

    <data-table-section
        :tableData="this.tableDataParam"
        :customRenderers="this.customRenderers"
        :isSelectEnabled="false"
        :isSearch="this.loading"
        ref="dataTableComponent"
        @datatableItems="syncItems"
      >
      <template v-slot:new_customers_percentageparams="{ item }">
        {{ Math.round(item.new_customers_percentage) }}%
      </template>

      <template v-slot:repeat_customers_percentageparams="{ item }">
        {{ Math.round(item.repeat_customers_percentage) }}%
      </template>
      <template v-slot:nameparams="{ item }">
        <v-btn text color="primary" @click="showDemographic(item)">
          {{ item.name.replace(item.street, '') }}
        </v-btn>
      </template>
      <template v-slot:streetparams="{ item }">
        {{ item.street }}
      </template>
      <template v-slot:potential_roiparams="{ item }">
        {{ numberWithCommas(item.potential_roi) }}
      </template>

      <template v-slot:total_salesparams="{ item }">
        {{ numberWithCommas(item.total_sales) }}
      </template>

      <template v-slot:previous_total_salesparams="{ item }">
        {{ numberWithCommas(item.previous_total_sales) }}
      </template>
    </data-table-section>
    
  </v-card>
</template>
<style scoped>
.height40{
  height: 40px;
}
.mwitdh200{
  max-width: 200px !important;;
}
</style>